import { render, staticRenderFns } from "./DaftarContainerBelumBerangkat.vue?vue&type=template&id=1233dc90&scoped=true&"
import script from "./DaftarContainerBelumBerangkat.vue?vue&type=script&lang=js&"
export * from "./DaftarContainerBelumBerangkat.vue?vue&type=script&lang=js&"
import style0 from "./DaftarContainerBelumBerangkat.vue?vue&type=style&index=0&id=1233dc90&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1233dc90",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VProgressLinear,VRow})
